import classNames from 'classnames';

import Button from 'shared/components/button/Button';
import ChevronDown from 'shared/components/icon/ChevronDown';
import Edit from 'shared/components/icon/Edit';
import Trash from 'shared/components/icon/Trash';
import VisibilityToggle from 'shared/components/VisibilityToggle';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

const CommentDropdown = ({
  onEdit,
  onDelete,
  onShow,
  loading,
  positionClassName,
}) => (
  <VisibilityToggle
    render={({ insideRefHandler, onToggleClick, visible }) => (
      <div ref={insideRefHandler}>
        <Button
          className={classNames(styles.menuOpenBtn, {
            [styles.open]: visible,
          })}
          disabled={loading}
          onClick={() => {
            onToggleClick();
            if (!visible) {
              onShow();
            }
          }}
        >
          <ChevronDown />
        </Button>

        {visible && (
          <ul className={classNames(styles.menu, positionClassName)}>
            <Button
              className={styles.menuItem}
              onClick={() => {
                onEdit();
                onToggleClick();
              }}
            >
              <Edit className={styles.icon} />
              {getText('page-live-chat-actions-edit')}
            </Button>

            <Button
              className={styles.menuItem}
              onClick={() => {
                onDelete();
                onToggleClick();
              }}
            >
              <Trash className={styles.icon} />
              {getText('page-live-chat-actions-delete')}
            </Button>
          </ul>
        )}
      </div>
    )}
  />
);

export default CommentDropdown;
